import { useState, useEffect } from 'react'
import { Button, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, Avatar } from '@material-ui/core'
import axiosConfig from '../../../utils/axiosConfig';

const RequestItem = ({participant, handleClose}) => {
    const [isAccepting, setIsAccepting] = useState(false)
    async function acceptRequest () {
        setIsAccepting(true)
        const response = await axiosConfig.post(`joinClass/request/accept`, {
            requestID: participant.request_id,
        })

        handleClose()
        setIsAccepting(false)
    }

    const [isRejecting, setIsRejecting] = useState(false)
    async function rejectRequest () {
        setIsRejecting(true)
        const response = await axiosConfig.post(`joinClass/request/reject`, {
            requestID: participant.request_id
        })

        handleClose()
        setIsRejecting(false)
    }

    return (
        <ListItem key={participant.id}>
            <ListItemAvatar>
                <Avatar alt="avatar" src={participant.avatar} />
            </ListItemAvatar>
            <ListItemText primary={`${participant.fn} ${participant.ln} | ${participant.lrn}`}/>
            <ListItemSecondaryAction>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        acceptRequest()
                    }}
                >
                    { isAccepting ? 'Accepting request...' : 'Accept' }
                </Button>
                <Button
                    variant="outlined"
                    color="default"
                    onClick={() => rejectRequest()}
                >
                    { isRejecting ? 'Rejecting request...' : 'Reject'}
                </Button>
            </ListItemSecondaryAction>
        </ListItem>
    )
}

export default RequestItem